import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { Paper, TableRow, TableCell, TableBody } from "@mui/material";
import PropTypes from "prop-types";

import Backdrop from "Components/Common/Backdrop";
import { usePagination } from "Components/Common/BaseTable";
import FixedRow from "Components/Common/BaseTable/FixedRow";
import Pagination from "Components/Common/BaseTable/Pagination";
import {
  StyledTable,
  StyledTableCell,
  StyledTableHead,
} from "pages/Admin/Reports/style";

import styled from "@emotion/styled";

const StyledTableContainer = styled(Paper, {
  shouldForwardProp: (prop) => prop !== "maxHeight",
})`
  max-height: ${({ maxHeight }) => maxHeight ?? "unset"};
  overflow-y: auto;
  .MuiPaper-root {
    overflow-x: scroll;
  }
`;

const BillCalculationTable = ({
  columns,
  isLoader,
  billCalculationData,
  bodyClassName,
  pageSize,
  registerResetPage,
  renderSubRow,
  maxHeight,
  t,
}) => {
  const [rowData, setRowData] = useState([]);

  const paginate = usePagination();
  const { page, setTotalPages, first } = paginate;
  const totalColumn = columns?.length || 0;
  const isAdjustmentShow = billCalculationData && billCalculationData.length > 0;

  useEffect(() => {
    if (billCalculationData) {
      setTotalPages(Math.ceil(billCalculationData.length / pageSize));
      const rowData = billCalculationData.slice(
        pageSize * (page - 1),
        pageSize * page
      );
      setRowData(rowData);
    }
  }, [page, pageSize, billCalculationData, setTotalPages]);

  useEffect(() => {
    registerResetPage(first);
  }, []);

  return (
    <>
      <StyledTableContainer maxHeight={maxHeight}>
        <Backdrop open={isLoader} />
        <StyledTable>
          <StyledTableHead
            sx={{
              backgroundColor: "#1B365D",
              position: "sticky",
              top: 0,
              zIndex: 2,
            }}
          >
            <TableRow>
              {columns.slice(0, 99)?.map((header, index) => (
                <StyledTableCell key={index} rowSpan={4}>
                  {t(header.title)}
                </StyledTableCell>
              ))}
              {isAdjustmentShow && (
                <StyledTableCell colSpan={3} align="center">
                  {t("Adjustments")}
                </StyledTableCell>
              )}
              {columns.slice(102, totalColumn)?.map((header, index) => (
                <StyledTableCell key={index} rowSpan={3}>
                  {t(`${header.title}`)}
                </StyledTableCell>
              ))}
            </TableRow>
            <TableRow>
              {columns.slice(99, 102)?.map((header, index) => (
                <StyledTableCell key={index} rowSpan={3}>
                  {t(`${header.title}`)}
                </StyledTableCell>
              ))}
            </TableRow>
          </StyledTableHead>
          <TableBody className={bodyClassName}>
            {rowData.length ? (
              rowData.map((item, rowIndex) => (
                <FixedRow
                  key={`${item.id}-${page}-${rowIndex}`}
                  rowIndex={rowIndex}
                  columns={columns}
                  page={page}
                  pageSize={pageSize}
                  item={item}
                  displaySrNo={true}
                  renderSubRow={renderSubRow}
                />
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={columns.length} className="text-center">
                  {t("No Data Available")}!
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </StyledTable>
      </StyledTableContainer>
      <Pagination paginate={paginate} />
    </>
  );
};

BillCalculationTable.propTypes = {
  isLoader: PropTypes.bool,
  billCalculationData: PropTypes.arrayOf(PropTypes.object),
  bodyClassName: PropTypes.string,
  pageSize: PropTypes.number,
  registerResetPage: PropTypes.func,
  renderSubRow: PropTypes.func,
  maxHeight: PropTypes.string,
  t: PropTypes.func.isRequired,
};

BillCalculationTable.defaultProps = {
  columns: [],
  isLoader: false,
  billCalculationData: [],
  bodyClassName: "",
  pageSize: 20,
  registerResetPage: () => {},
  renderSubRow: () => null,
  t: () => {},
};

export default withTranslation()(BillCalculationTable);
